import { render, staticRenderFns } from "./MainOffer.vue?vue&type=template&id=3b1fc74a&scoped=true&"
import script from "./MainOffer.vue?vue&type=script&lang=js&"
export * from "./MainOffer.vue?vue&type=script&lang=js&"
import style0 from "./MainOffer.vue?vue&type=style&index=0&id=3b1fc74a&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1fc74a",
  null
  
)

export default component.exports